module.exports = __webpack_public_path__ + "media/corporate-image/tachikawalogo-removebg-49f4c10d3954346880a20b8293552201.png";